







































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_SUBUNIT } from './getSubunit';

@Component
export default class SubUnitShow extends Vue {
  private GET_SUBUNIT = GET_SUBUNIT;
  @Prop(String) private id!: string;
}
